export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'and',
'_.loadingSpinnerText': 'Please wait...',
'pageTimerMax.text': 'You will automatically be taken to the next page after the time expires.',
'pageTimerMax.timeLeft': 'Time remaining',
'pageTimerMin.text': 'There is no option to move on before the time expires.',
'pageTimerMin.timeLeft': 'Time remaining',
'pageTimerMin.allowNext': 'You can proceed further',
'survey.registerForm.label.email': 'E-mail',
'survey.registerForm.label.newsletter': 'I would like to receive the newsletter',
'survey.registerForm.label.regulations': 'I accept the Privacy Policy and Terms and Conditions',
'survey.registerForm.button.register': 'Register',
'survey.registerForm.registered': 'Thank you for registering. An email with an activation link has been sent to your email inbox.',
'survey.registerForm.cardHeader': 'Register and receive points!',
'survey.registerForm.cardBody': 'For completing the survey you received',
'survey.registerForm.cardBody2': 'Points will be credited to you after you register an account with swpanel.co.uk. Enter your email address and register an account at swpanel.pl' ,
'survey.notProperDevice': 'Unfortunately, you cannot complete this survey on this device.',
'survey.properDevices': 'The survey can be accessed from the following devices:',
'survey.device-phone': 'smartphone',
'survey.device-tablet': 'tablet',
'survey.device-desktop': 'computer / laptop',
'survey.device-android': '<a href="https://play.google.com/store/apps/details?id=org.reactjs.swpanel">mobile application for Android</a>',
'survey.device-ios': '<a href="https://apps.apple.com/pl/app/swpanel/id6449539314">mobile application for iOS</a>',
'nextSurveys.header.seeAlso': 'See also other surveys',
'nextSurveys.button.fill': 'Fill out',
'question.noContent': 'Question content missing',
'question.input.placeholder.typeYourAnswer': 'Enter your answer',
'question.slider.input': "Enter your answer",

'question.basket.moveToBaskets': "Move to baskets",
'question.dragAndDrop.moveToTarget': "Move to scale",

'question.conjoint.go': 'Click the "Next" button',
'question.matrix.carousel.go': 'Click the "Next" button',
'question.carousel.prevBtn': 'Previous statement',
'question.carousel.nextBtn': 'Next statement',
'question.matrix.columnsMin': 'Min numbers of columns is:',
'question.matrix.rowsMin': 'Min number of rows is:',

'question.open.email.inputPlaceholder': 'Enter email address',
'question.open.email.emailVerify.sendCode': 'Send verification code',
'question.open.email.emailVerify.enderCode': 'Enter the code you received',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Enter the code',
'question.open.email.emailVerify.confirm': 'Confirm',
'question.open.email.emailVerify.codeIncorrect': 'The code you entered is incorrect',
'question.open.email.emailVerify.codeCorrect': 'E-mail address correctly verified',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',
'question.dropdown.open': 'Select...',
'question.column': "Column",
'question.matrix.nextStatement': 'Next statement',
'question.matrix.previousStatement': 'Previous statement',

'footer.pauseButton.text': 'Pause filling',
'footer.buttonPrev.text': 'Undo',
'footer.buttonClear.text': 'Clear',
'footer.buttonNext.text': 'Next',
'footer.buttonEnd.text': 'Finish',
'footer.buttonStart.text': 'Start survey',
};
